import React from 'react'
import {useStyles} from './styles'


//custom components
import GraphCard from './GraphCard'

//material ui 
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import CardActions from '@material-ui/core/CardActions'
import Typography from '@material-ui/core/Typography'

function TimeOccurrences(){
    const classes = useStyles();
    return (
        <Card className={classes.root}>
        <CardContent>
        <Typography className={classes.title} color="textSecondary" gutterBottom>
        <b>Tempo em Ocorrências</b>
        </Typography>
        <GraphCard />
        </CardContent>
            <CardActions></CardActions>
        </Card>
    )
}


export default TimeOccurrences;